(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calcolatore-run"] && !Shopify.designMode) return;
  try {
    
  // Funzione per gestire il calcolo, specifica per questa sezione
  function handlePaceCalculation(sectionId) {
    // Trova gli elementi all'interno della sezione specifica
    const sectionElement = document.getElementById(sectionId);
    if (!sectionElement) return; // Esce se la sezione non è trovata

    const distanzaInput = sectionElement.querySelector('#distanza-' + sectionId);
    const oreInput = sectionElement.querySelector('#ore-' + sectionId);
    const minutiInput = sectionElement.querySelector('#minuti-' + sectionId);
    const secondiInput = sectionElement.querySelector('#secondi-' + sectionId);
    const risultatoDiv = sectionElement.querySelector('#pace-risultato-' + sectionId);

    // Converti valori
    const distanza = parseFloat(distanzaInput.value);
    const ore = parseInt(oreInput.value) || 0;
    const minuti = parseInt(minutiInput.value) || 0;
    const secondi = parseInt(secondiInput.value) || 0;

    // Reset stile risultato
    risultatoDiv.style.display = 'none';
    risultatoDiv.className = '';

    // Validazione (simile a prima, ma selezionando elementi dentro la sezione)
    let errore = false;
    [distanzaInput, oreInput, minutiInput, secondiInput].forEach(input => input.style.borderColor = '#cccccc'); // Reset bordi

    if (isNaN(distanza) || distanza <= 0) { distanzaInput.style.borderColor = 'red'; errore = true; }
    if (isNaN(ore) || ore < 0) { oreInput.style.borderColor = 'red'; errore = true; }
    if (isNaN(minuti) || minuti < 0 || minuti >= 60) { minutiInput.style.borderColor = 'red'; errore = true; }
    if (isNaN(secondi) || secondi < 0 || secondi >= 60) { secondiInput.style.borderColor = 'red'; errore = true; }

    if (errore) {
      risultatoDiv.textContent = 'Per favore, inserisci valori validi.';
      risultatoDiv.className = 'error';
      risultatoDiv.style.display = 'block';
      return;
    }

    const tempoTotaleSecondi = (ore * 3600) + (minuti * 60) + secondi;
    if (tempoTotaleSecondi <= 0) {
         risultatoDiv.textContent = 'Il tempo totale deve essere maggiore di zero.';
         risultatoDiv.className = 'error';
         risultatoDiv.style.display = 'block';
         return;
    }

    const secondiPerKm = tempoTotaleSecondi / distanza;
    const minutiPienoPerKm = Math.floor(secondiPerKm / 60);
    const secondiRestantiPerKm = Math.round(secondiPerKm % 60);
    const secondiFormattati = secondiRestantiPerKm < 10 ? '0' + secondiRestantiPerKm : secondiRestantiPerKm;

    risultatoDiv.textContent = `Il tuo ritmo gara calcolato è: ${minutiPienoPerKm}'${secondiFormattati}" / km`;
    risultatoDiv.className = 'success';
    risultatoDiv.style.display = 'block';
  }

  // Aggiungi l'event listener al pulsante specifico di questa sezione
  // È importante eseguirlo dopo che il DOM è caricato o alla fine dello script
  document.addEventListener('DOMContentLoaded', function() {
      const sectionId = '{{ section.id }}'; // Ottiene l'ID univoco della sezione da Liquid
      const sectionElement = document.getElementById(sectionId);
      if(sectionElement) {
          const button = sectionElement.querySelector('.pace-calculate-button');
          if (button) {
            button.addEventListener('click', function() {
              handlePaceCalculation(sectionId); // Chiama la funzione passando l'ID della sezione
            });
          }
      }
  });

  // Potrebbe essere necessario rieseguire l'attach dell'evento in caso di modifiche nel Theme Editor
  document.addEventListener('shopify:section:load', function(event) {
    const sectionId = event.detail.sectionId;
    const sectionElement = event.target; // L'elemento della sezione caricato/modificato
     if(sectionElement && sectionElement.querySelector('.pace-calculate-button')) {
          const button = sectionElement.querySelector('.pace-calculate-button');
          if (button) {
              // Rimuovi listener precedenti per sicurezza se ce ne fossero
              button.replaceWith(button.cloneNode(true)); // Clona per rimuovere vecchi listener
              const newButton = sectionElement.querySelector('.pace-calculate-button'); // Riseleziona il bottone clonato
              newButton.addEventListener('click', function() {
                  handlePaceCalculation(sectionId);
              });
          }
     }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
